export default __webpack_public_path__ + "static/ocbc-819af754503a2151bccefc91d50b9c10.png";